import { http } from '../shared/api';

export const listLegalEntities = (config) => http.get('/api/legal-entities', config);